import './style.module.scss';
import MenuItem from '@widgets/sidebar/components/menu-item';
import SubMenuItem from '@widgets/sidebar/components/sub-menu-item';
import useSidebar from '@app/hooks/useSidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import IconLogoDarkTheme from '@shared/icons/IconLogoDarkTheme';
import useMenu from '@app/hooks/useMenu';
import IconViaBtc from '@shared/icons/IconViaBtc';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectIsManager } from '@app/redux/features/userSlice';

const Sidebar = () => {
  const [showSidebar, toggleShowSidebar, toggleToShowSidebar] = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();
  const menu = useMenu(location.pathname);
  const user = useSelector(selectCurrentUser);

  const isSalesTeam = user.user?.is_sales_team === true;
  const isAdmin = user.user?.is_admin === true;

  return (
    <div
      className={`${showSidebar ? 'w-[221px] expanded' : 'min-w-[68px]'} h-screen relative pr-[21px] border border-opacity-30 border-r-[#959595] border-y-0 border-l-0  pt-[24px] rounded-[20px]`}
    >
      <div onClick={() => navigate('/via-btc/main')} className="cursor-pointer">
        <div className="absolute w-[47px] h-[47px]">
          <IconLogoDarkTheme />
        </div>

        {showSidebar ? (
          <div className="absolute top-[35px] left-[59px] text-[18px]">
            <span className="font-black">INTERHASH</span>
          </div>
        ) : null}

        <div
          className="cursor-pointer absolute right-[-16px] top-[33px]"
          onClick={event => {
            toggleShowSidebar();
            event.stopPropagation();
          }}
        >
          <svg
            width="15"
            height="30"
            viewBox="0 0 15 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="path-1-inside-1_2548_15063" fill="white">
              <path d="M-1.31134e-06 30C3.97825 30 7.79355 28.4196 10.6066 25.6066C13.4196 22.7936 15 18.9782 15 15C15 11.0218 13.4196 7.20645 10.6066 4.3934C7.79356 1.58035 3.97825 1.18923e-07 1.90735e-06 -6.55671e-07L-6.55671e-07 15L-1.31134e-06 30Z" />
            </mask>
            <path
              d="M-1.31134e-06 30C3.97825 30 7.79355 28.4196 10.6066 25.6066C13.4196 22.7936 15 18.9782 15 15C15 11.0218 13.4196 7.20645 10.6066 4.3934C7.79356 1.58035 3.97825 1.18923e-07 1.90735e-06 -6.55671e-07L-6.55671e-07 15L-1.31134e-06 30Z"
              fill="#211F24"
              stroke="#1D1C1F"
              strokeWidth="2"
              mask="url(#path-1-inside-1_2548_15063)"
            />
          </svg>
          <svg
            transform={showSidebar ? 'rotate(-180)' : ''}
            className="absolute top-[12px] right-[6px]"
            width="5"
            height="7"
            viewBox="0 0 5 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.62774 6.8861C0.457421 6.73423 0.457421 6.488 0.62774 6.33613L3.5 3.77499C3.67032 3.62312 3.67032 3.37688 3.5 3.22501L0.62774 0.663874C0.45742 0.512004 0.45742 0.265774 0.62774 0.113903C0.798059 -0.0379674 1.0742 -0.0379674 1.24452 0.113903L4.11678 2.67504C4.62774 3.13065 4.62774 3.86935 4.11678 4.32496L1.24452 6.8861C1.0742 7.03797 0.79806 7.03797 0.62774 6.8861Z"
              fill="#959595"
            />
          </svg>
        </div>
      </div>

      <div className="pt-[66px] text-[#959595]">
        <MenuItem
          icon={<IconViaBtc fill={menu.isActive('/via-btc') ? 'white' : '#959595'} />}
          title="ViaBTC"
          active={menu.isActive('/via-btc')}
          showSidebar={showSidebar}
          onClick={() => {
            toggleToShowSidebar();
            navigate('/via-btc/main');
          }}
        >
          <SubMenuItem
            title="Основные показатели"
            active={menu.isActive('/via-btc/main')}
            href="/via-btc/main"
          />

          <SubMenuItem
            active={menu.isActive('/via-btc/customer')}
            title="Обзор клиентов"
            href="/via-btc/customer"
          />

          <SubMenuItem
            active={menu.isActive('/via-btc/account')}
            title="Обзор аккаунтов"
            href="/via-btc/account"
          />

          {!isSalesTeam || isAdmin ? (
            <SubMenuItem
              active={menu.isActive('/via-btc/board')}
              title="Заявки на подключение"
              href="/via-btc/board"
            />
          ) : null}

          <SubMenuItem
            active={menu.isActive('/via-btc/lost')}
            title="Отключение мощности"
            href="/via-btc/lost"
          />

          <SubMenuItem
            active={menu.isActive('/via-btc/dynamics')}
            title="Динамика по аккаунтам"
            href="/via-btc/dynamics/"
          />

          {!isSalesTeam || isAdmin ? (
            <SubMenuItem
              active={menu.isActive('/via-btc/managers-performance')}
              title="Показатели менеджеров"
              href="/via-btc/managers-performance/"
            />
          ) : null}

          {/*
                <SubMenuItem
                    title='Отключение мощности'
                    active={menu.isActive('/stats/power-off')}
                    onClick={() => {navigate('/stats/power-off')}}
                />
                */}
          {!isSalesTeam || isAdmin ? (
            <SubMenuItem
              title="Загрузка репортов"
              active={menu.isActive('/via-btc/upload')}
              href="/via-btc/upload"
            />
          ) : null}
        </MenuItem>
        {/*<MenuItem*/}
        {/*    icon={*/}
        {/*        <IconHisting*/}
        {/*            fill={*/}
        {/*                menu.isActive('/hosting') ? 'white' : '#959595'*/}
        {/*            }*/}
        {/*        />*/}
        {/*    }*/}
        {/*    title='Хостинги'*/}
        {/*    active={menu.isActive('/hosting')}*/}
        {/*    showSidebar={showSidebar}*/}
        {/*    onClick={() => {*/}
        {/*        toggleToShowSidebar()*/}
        {/*        navigate('/hosting/main')*/}
        {/*    }}*/}
        {/*>*/}
        {/*    <SubMenuItem*/}
        {/*        title='Основные показатели'*/}
        {/*        active={menu.isActive('/hosting/main')}*/}
        {/*        href='/hosting/main'*/}
        {/*    />*/}
        {/*    <SubMenuItem*/}
        {/*        title='Обзор хостингов'*/}
        {/*        active={menu.isActive('/hosting/list')}*/}
        {/*        href='/hosting/list'*/}
        {/*    />*/}
        {/*</MenuItem>*/}
        {/*
            <MenuItem
                icon={<IconFinance />}
                title='финансы'
                active={menu.isActive('finance')}
                showSidebar={showSidebar}
                onClick={() => {
                    toggleToShowSidebar()
                    navigate('/finance')
                }}
            />
            <MenuItem
                icon={<IconUser className='w-[23px] h-[22px]' />}
                title='сотрудники'
                active={menu.isActive('user')}
                showSidebar={showSidebar}
                onClick={() => {
                    toggleToShowSidebar()
                    navigate('/user')
                }}
            />
            */}
        {/*
            <MenuItem
                icon={<></>}
                title='выход'
                showSidebar={showSidebar}
                active={menu.isActive('exit')}
                onClick={() => {
                    localStorage.clear();
                    navigate('/login')
                }}
            />
            */}
      </div>
    </div>
  );
};

export default Sidebar;
